import slugify from 'slugify';

import { Field } from '.';

export function getFieldId(field: Field | undefined) {
  if (!field) return '';
  return field.fieldId || slugify(field.label, { lower: true, strict: true });
}
